/**
 * Atomic Design - Alert Molecule
 * Message component for displaying alerts and notifications
 */

<template>
  <div :class="['ds-alert', `ds-alert--${variant}`, { 'ds-alert--dismissible': dismissible }]">
    <div class="ds-alert__icon">
      <slot name="icon" />
    </div>

    <div class="ds-alert__content">
      <div v-if="title" class="ds-alert__title">
        {{ title }}
      </div>
      <div class="ds-alert__message">
        <slot />
      </div>
    </div>

    <button
      v-if="dismissible"
      class="ds-alert__close"
      @click="$emit('dismiss')"
      aria-label="Fechar alerta"
    >
      ✕
    </button>
  </div>
</template>

<script setup>
defineProps({
  variant: {
    type: String,
    default: 'info',
    validator: (v) => ['info', 'success', 'warning', 'error'].includes(v),
  },
  title: {
    type: String,
    default: '',
  },
  dismissible: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['dismiss']);
</script>

<style scoped>
.ds-alert {
  display: flex;
  gap: var(--spacing-base);
  padding: var(--spacing-base);
  border-radius: var(--radius-lg);
  border: 1px solid;
  background-color: var(--color-surface);
  transition: var(--transition-default);
}

/* Variants */
.ds-alert--info {
  background-color: var(--color-info-light);
  border-color: var(--color-info);
  color: var(--color-info);
}

.ds-alert--success {
  background-color: var(--color-success-light);
  border-color: var(--color-success);
  color: var(--color-success);
}

.ds-alert--warning {
  background-color: var(--color-warning-light);
  border-color: var(--color-warning);
  color: var(--color-warning);
}

.ds-alert--error {
  background-color: var(--color-error-light);
  border-color: var(--color-error);
  color: var(--color-error);
}

.ds-alert__icon {
  flex-shrink: 0;
  display: flex;
  align-items: flex-start;
  padding-top: 2px;
}

.ds-alert__content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-sm);
}

.ds-alert__title {
  font-weight: 600;
  font-size: var(--font-size-label);
}

.ds-alert__message {
  font-size: var(--font-size-body-small);
  line-height: var(--line-height-normal);
}

.ds-alert__close {
  flex-shrink: 0;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  padding: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: var(--transition-default);
  opacity: 0.7;
}

.ds-alert__close:hover {
  opacity: 1;
  transform: scale(1.1);
}

.ds-alert--dismissible {
  padding-right: var(--spacing-md);
}
</style>
